import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getReminder(organizationId, params) {
    const url = `/api/v1/organizations/${organizationId}/reminders`
    return HTTP.get(url, {
      params,
      paramsSerializer: function(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    })
  },

  createReminder(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/reminders`
    return HTTP.post(url, payload)
  },

  updateReminder(organizationId, reminderId, payload) {
    const url = `/api/v1/organizations/${organizationId}/reminders/${reminderId}`
    return HTTP.patch(url, payload)
  },

  deleteReminder(organizationId, reminderId) {
    const url = `/api/v1/organizations/${organizationId}/reminders/${reminderId}`
    return HTTP.delete(url)
  },
}
